var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Navbar"),
      _c(
        "div",
        { staticClass: "step-page" },
        [
          _vm._m(0),
          _vm._m(1),
          _c(
            "el-tabs",
            {
              staticClass: "tab-component",
              attrs: {
                "tab-position": _vm.windowWidth > 1024 ? "left" : "top",
              },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "面談背景資料", name: "面談背景資料" } },
                [
                  _c(
                    "span",
                    {
                      staticClass: "resume-tab",
                      class: {
                        finish: _vm.resumeCompleteness.IsDLWorkedInfoComplete,
                      },
                      attrs: { slot: "label" },
                      slot: "label",
                    },
                    [
                      _c("span", { staticClass: "tab-name" }, [
                        _vm._v(" 面談背景資料"),
                        _c("br"),
                        _vm._v(" Interview background "),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "step-content no-bg mt-1" },
                    [
                      _vm.activeName === "面談背景資料"
                        ? _c("WorkedInfo", {
                            key: _vm.workedInfoKey,
                            attrs: { source: "resume", nextTab: "個人資料" },
                            on: { changeTab: _vm.changeTab },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "個人資料", name: "個人資料" } },
                [
                  _c(
                    "span",
                    {
                      staticClass: "resume-tab",
                      class: {
                        finish: _vm.resumeCompleteness.IsDLBaseInfoComplete,
                      },
                      attrs: { slot: "label" },
                      slot: "label",
                    },
                    [
                      _c("span", { staticClass: "tab-name" }, [
                        _vm._v(" 個人資料"),
                        _c("br"),
                        _vm._v(" Personal information "),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "step-content no-bg" },
                    [
                      _c("div", { staticClass: "step-tip mb-2" }, [
                        _vm._v(
                          " ** 以下任何欄位皆基於工作所需而請求應徵者提供，若認為涉及個人資料而不願透漏，可選擇不填。"
                        ),
                        _c("br"),
                        _c("span", { staticClass: "en-text" }, [
                          _vm._v(
                            "The applicant must fill out the following fields based on job requirements, if do not want to disclose personal information, can select not to fill out."
                          ),
                        ]),
                      ]),
                      _vm.activeName === "個人資料"
                        ? _c("BaseInfo", {
                            key: _vm.baseInfoKey,
                            attrs: { source: "resume", nextTab: "工作條件" },
                            on: { changeTab: _vm.changeTab },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "工作條件", name: "工作條件" } },
                [
                  _c(
                    "span",
                    {
                      staticClass: "resume-tab",
                      class: {
                        finish:
                          _vm.resumeCompleteness.IsDLWorkConditionComplete,
                      },
                      attrs: { slot: "label" },
                      slot: "label",
                    },
                    [
                      _c("span", { staticClass: "tab-name" }, [
                        _vm._v(" 工作條件"),
                        _c("br"),
                        _vm._v(" Work Conditions "),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "step-content no-bg" },
                    [
                      _vm.activeName === "工作條件"
                        ? _c("WorkCondition", {
                            key: _vm.workConditionKey,
                            attrs: { source: "resume", nextTab: "學歷" },
                            on: { changeTab: _vm.changeTab },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _c("el-tab-pane", { attrs: { label: "學歷", name: "學歷" } }, [
                _c(
                  "span",
                  {
                    staticClass: "resume-tab",
                    class: {
                      finish: _vm.resumeCompleteness.IsDLEducationComplete,
                    },
                    attrs: { slot: "label" },
                    slot: "label",
                  },
                  [
                    _c("span", { staticClass: "tab-name" }, [
                      _vm._v(" 學歷"),
                      _c("br"),
                      _vm._v(" Education "),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "step-content no-bg" },
                  [
                    _vm.activeName === "學歷"
                      ? _c("Education", {
                          key: _vm.educationKey,
                          attrs: { source: "resume", nextTab: "工作經歷" },
                          on: { changeTab: _vm.changeTab },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _c(
                "el-tab-pane",
                { attrs: { label: "工作經歷", name: "工作經歷" } },
                [
                  _c(
                    "span",
                    {
                      staticClass: "resume-tab",
                      class: {
                        finish:
                          _vm.resumeCompleteness.IsDLWorkExperienceComplete,
                      },
                      attrs: { slot: "label" },
                      slot: "label",
                    },
                    [
                      _c("span", { staticClass: "tab-name" }, [
                        _vm._v(" 工作經歷"),
                        _c("br"),
                        _vm._v(" Work Experience "),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "step-content no-bg" },
                    [
                      _vm.activeName === "工作經歷"
                        ? _c("WorkExperience", {
                            key: _vm.workExperienceKey,
                            attrs: { source: "resume", nextTab: "專業技能" },
                            on: { changeTab: _vm.changeTab },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "專業技能", name: "專業技能" } },
                [
                  _c(
                    "span",
                    {
                      staticClass: "resume-tab",
                      class: {
                        finish: _vm.resumeCompleteness.IsDLSkillComplete,
                      },
                      attrs: { slot: "label" },
                      slot: "label",
                    },
                    [
                      _c("span", { staticClass: "tab-name" }, [
                        _vm._v(" 專業技能"),
                        _c("br"),
                        _vm._v(" Professional skills "),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "step-content no-bg" },
                    [
                      _c("div", { staticClass: "step-tip mb-2" }, [
                        _vm._v(
                          " ** 請填寫具備的電腦技能、培訓紀錄、證照檢定、工作專長"
                        ),
                        _c("br"),
                        _c("span", { staticClass: "en-text" }, [
                          _vm._v(
                            "Please fill out if you possess computer skills, training records, work skill"
                          ),
                        ]),
                      ]),
                      _vm.activeName === "專業技能"
                        ? _c("Skill", {
                            key: _vm.skillKey,
                            attrs: { source: "resume", nextTab: "自傳" },
                            on: { changeTab: _vm.changeTab },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _c("el-tab-pane", { attrs: { label: "自傳", name: "自傳" } }, [
                _c(
                  "span",
                  {
                    staticClass: "resume-tab",
                    class: {
                      finish: _vm.resumeCompleteness.IsIDLAutobiographyComplete,
                    },
                    attrs: { slot: "label" },
                    slot: "label",
                  },
                  [
                    _c("span", { staticClass: "tab-name" }, [
                      _vm._v(" 自傳"),
                      _c("br"),
                      _vm._v(" Autobiography "),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "step-content no-bg" },
                  [
                    _vm.activeName === "自傳"
                      ? _c("Autobiography", {
                          key: _vm.autobiographyKey,
                          attrs: { source: "resume" },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title" }, [
      _c(
        "span",
        { staticStyle: { "font-size": "1.8rem", "font-weight": "bold" } },
        [_vm._v("DL 直接人員面談資料表")]
      ),
      _c("br"),
      _c("span", { staticClass: "en-text" }, [
        _vm._v("DL Interview Information Form"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title" }, [
      _c("span", { staticStyle: { "font-weight": "bold" } }, [
        _vm._v("應徵生產助理員、作業員、技術員、生產技術員、助理等職務"),
        _c("br"),
      ]),
      _c("span", { staticClass: "en-text" }, [
        _vm._v(
          "Apply for production assistant, operator, technician, production technician"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }